import React from "react";
import Link from "next/link";

// Omit "as" property as this is not compatible with several components from design system
const NextLink: React.FC<Omit<React.ComponentProps<typeof Link>, "as">> = Link;

export default NextLink;
